import * as React from 'react';

import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';

import { formattedNumber } from '@utils/formattedNumber.ts';
import { getBrandImage } from '@utils/get-brand-image.ts';

import promobg_2 from '@assets/images/home/home_product_2.png';
import promobg_3 from '@assets/images/home/home_product_3.png';
import promobg_4 from '@assets/images/home/home_product_4.png';
import bannerBg from '@assets/images/home/promo_banner_bg.png';

import useGetPointsIcon from '@hooks/use-get-points-icon.tsx';

import { Button } from '@components/button';

import { config } from '@/config.ts';

import * as Styled from './promo-group.styled.ts';

const getBannerBgKey = (isCom2: boolean, language: string) => {
	if (!isCom2) {
		return 'promoBannerBg';
	}

	if(language === 'en') {
		return 'promoBannerBgEn';
	}

	if(language === 'ru') {
		return 'promoBannerBgRu';
	}

	return 'promoBannerBg';
};

const PromoGroup = () => {
	const PointsIcon = useGetPointsIcon();

	const brand = config.BRAND || 'default';

	const isXpBrand = brand === 'ngu3' || brand === 'com2';
	const isCom2 = brand === 'com2';

	const { t, i18n } = useTranslation(isXpBrand ? 'promogroupXp' : 'promogroup');
	const boxImage = getBrandImage('box');

	const bannerBgKey = getBannerBgKey(isCom2, i18n.language);

	const bannerBgCom2 = getBrandImage(bannerBgKey);
	const bannerBgCom2Mob = getBrandImage('promoBannerBgMob');

	return (
		<Styled.Wrapper>
			<Styled.Section>
				{!isXpBrand && (
					<>
						<Styled.Title>
							{t('title')} <span>{t('title_hg')}</span>
						</Styled.Title>
						<Styled.Group>
							{/*<Styled.PromoItem $bgImg={promobg_1}>*/}
							{/*	<Styled.Info>*/}
							{/*		<Styled.Name>{t('pic1_name')}</Styled.Name>*/}
							{/*		<Styled.Desc>*/}
							{/*			{formattedNumber(10000) + ' ' + t('points_p')} {PointsIcon}*/}
							{/*		</Styled.Desc>*/}
							{/*	</Styled.Info>*/}
							{/*</Styled.PromoItem>*/}
							<Styled.PromoItem $bgImg={promobg_2}>
								<Styled.Info>
									<Styled.Name>{t('pic2_name')}</Styled.Name>
									<Styled.Desc>
										{formattedNumber(35000) + ' ' + t('points_p')} {PointsIcon}
									</Styled.Desc>
								</Styled.Info>
							</Styled.PromoItem>
							<Styled.PromoItem $bgImg={promobg_3}>
								<Styled.Info>
									<Styled.Name>{t('pic3_name')}</Styled.Name>
									<Styled.Desc>
										{formattedNumber(35000) + ' ' + t('points_p')} {PointsIcon}
									</Styled.Desc>
								</Styled.Info>
							</Styled.PromoItem>
							<Styled.PromoItem $bgImg={promobg_4}>
								<Styled.Info>
									<Styled.Name>{t('pic4_name')}</Styled.Name>
									<Styled.Desc>
										{formattedNumber(10000) + ' ' + t('points_p')} {PointsIcon}
									</Styled.Desc>
								</Styled.Info>
							</Styled.PromoItem>
						</Styled.Group>
					</>
				)}
				<Styled.Banner
					$isCom2={isCom2}
					$bannerBgCom2={bannerBgCom2}
					$bannerBgCom2Mob={bannerBgCom2Mob}
					$bannerBg={bannerBg}
				>
					<Styled.BannerInfo>
						<Styled.BannerTitle>
							{t('desc_title')} <br />
							<span>{t('desc_title_hg')}</span>
						</Styled.BannerTitle>
						<NavLink to='/shop'>
							<Button color='primary' size='large'>
								{t('shop')}
							</Button>
						</NavLink>
					</Styled.BannerInfo>
					<Styled.BannerImage src={boxImage} />
				</Styled.Banner>
			</Styled.Section>
		</Styled.Wrapper>
	);
};

export default PromoGroup;
